// import React, { useRef, useEffect, useState } from "react";
// import { Button, Container } from "react-bootstrap";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import {
//   formatToDate,
//   formatToMonth,
//   formatToUSDate,
// } from "../../utils/dateFormat";
// import { HiOutlineLocationMarker } from "react-icons/hi";
// import { FaRegClock } from "react-icons/fa";
// import DefaultEventImage from "../../assets/images/event/DefaultEventPhoto.svg";
// import { Link, NavLink, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";

// const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

// export default function LatestEvents({ nextMonthUpcomingEvents, loading }) {
//   const sliderRef = useRef(null);
//   const navigate = useNavigate();
//   const { user } = useSelector((state) => state.USER_DATA);
// const [mounted, setMounted] = useState(false);

// useEffect(() => {
//   const timer = setTimeout(() => {
//     window.dispatchEvent(new Event("resize"));
//   }, 100);

//   return () => clearTimeout(timer);
// }, []);

//   // const settings = {
//   //   centerMode: true,
//   //   centerPadding: "100px",
//   //   slidesToShow: 2.2,
//   //   slidesToScroll: 1,
//   //   focusOnSelect: true,
//   //   infinite: true,
//   //   speed: 500,
//   //   arrows: false,
//   //   responsive: [
//   //     {
//   //       breakpoint: 1400,
//   //       settings: {
//   //         centerPadding: "18%",
//   //         slidesToShow: 1,
//   //       },
//   //     },
//   //     {
//   //       breakpoint: 1200,
//   //       settings: {
//   //         centerPadding: "15%",
//   //         slidesToShow: 1,
//   //       },
//   //     },
//   //     {
//   //       breakpoint: 992,
//   //       settings: {
//   //         centerPadding: "12%",
//   //         slidesToShow: 1,
//   //       },
//   //     },
//   //     {
//   //       breakpoint: 768,
//   //       settings: {
//   //         arrows: false,
//   //         centerMode: true,
//   //         centerPadding: "60px",
//   //         slidesToShow: 1,
//   //       },
//   //     },
//   //     {
//   //       breakpoint: 480,
//   //       settings: {
//   //         arrows: false,
//   //         centerMode: true,
//   //         centerPadding: "40px",
//   //         slidesToShow: 1,
//   //       },
//   //     },
//   //   ],
//   // };
//   const settings = {
//     infinite: true,
//     speed: 500,
//     arrows: false,
//     focusOnSelect: true,

//     // DESKTOP
//     centerMode: true,
//     centerPadding: "100px",
//     slidesToShow: 2.2,

//     responsive: [
//       {
//         breakpoint: 1200, // tablet landscape
//         settings: {
//           centerMode: true,      // 🔑 IMPORTANT
//           centerPadding: "0px",   // 🔑 IMPORTANT
//           slidesToShow: 1,
//         },
//       },
//       {
//         breakpoint: 992, // tablet portrait
//         settings: {
//           centerMode: false,
//           centerPadding: "0px",
//           slidesToShow: 1,
//         },
//       },
//       {
//         breakpoint: 768, // mobile
//         settings: {
//           centerMode: false,
//           centerPadding: "0px",
//           slidesToShow: 1,
//         },
//       },
//       {
//         breakpoint: 480, // small mobile
//         settings: {
//           centerMode: false,
//           centerPadding: "0px",
//           slidesToShow: 1,
//         },
//       },
//     ],
//   };

//   return (
//     <section className="latest-events my-5 py-5">
//       <Container>
//         {/* Title Row */}
//         <div className="d-flex justify-content-center text-center mb-4">
//           <div className="d-flex justify-content-center align-items-center flex-column ms-auto home-headers">
//             <h2 className="team-title mb-2 h1">Latest Events</h2>
//           </div>
//           <NavLink
//             as={Link}
//             to="/events"
//             className="view-all-link ms-auto text-decoration-none"
//           >
//             View All
//           </NavLink>
//         </div>

//         <div className="position-relative latest-events-wrapper">
//           {loading || !nextMonthUpcomingEvents ? (
//             <div className="d-flex justify-content-center align-items-center">
//               <Skeleton height={450} width={800} borderRadius={12} />
//             </div>
//           ) : (
//             <Slider
//             key={mounted ? "slider-mounted" : "slider"}
//               ref={sliderRef}
//               {...settings}
//               className="latest-events-slider"
//             >
//               {nextMonthUpcomingEvents.map((event, idx) => {
//                 const parseDate = (value) => {
//                   if (!value || typeof value !== "string") return null;
//                   const d = new Date(value);
//                   return Number.isNaN(d.getTime()) ? null : d;
//                 };

//                 const startDate = parseDate(event?.start_date);
//                 const endDate = parseDate(event?.end_date);

//                 let dateLabel;
//                 if (!startDate) {
//                   dateLabel = "TBD";
//                 } else if (
//                   endDate &&
//                   startDate.toDateString() !== endDate.toDateString()
//                 ) {
//                   dateLabel = `${formatToUSDate(
//                     event?.start_date
//                   )} - ${formatToUSDate(event?.end_date)}`;
//                 } else {
//                   dateLabel = formatToUSDate(event?.start_date);
//                 }

//                 return (
//                   <div key={event._id} className="slider-item-wrapper">
//                     <div className="event-carousel-card">
//                       <img
//                         src={
//                           event.image_path
//                             ? `${IMAGE_BASEURL}${event.image_path}`
//                             : DefaultEventImage
//                         }
//                         alt={event.title}
//                         className="event-slider-img"
//                       />

//                       {/* Date Badge */}
//                       <div className="event-date-badge">
//                         <div className="date-number">
//                           {formatToDate(event.start_date)}
//                         </div>
//                         <div className="date-month">
//                           {formatToMonth(event.start_date)}
//                         </div>
//                       </div>

//                       {/* Event Details Card - Only visible on center slide */}
//                       <div className="event-details-overlay">
//                         <h4 className="event-overlay-title">{event.title}</h4>
//                         {event?.price && (
//                           <div className="event-overlay-price">
//                             {user && user.is_membership_active ? (
//                               <span>Free to 2026 Members</span>
//                             ) : (
//                               <span>Non-Members ${Number(event.price).toFixed(2)}</span>
//                             )}
//                           </div>
//                         )}

//                         <div className="event-overlay-info">
//                           <div className="d-flex align-items-center mb-2">
//                             <FaRegClock />
//                             <span className="ms-2">{dateLabel}</span>
//                           </div>
//                           <div className="d-flex align-items-center mb-3">
//                             <HiOutlineLocationMarker />
//                             <span className="mx-2">
//                               {event?.venue || "TBD"}
//                             </span>
//                           </div>
//                         </div>

//                         <Button className="btn-event-details" onClick={() => {
//                           navigate(`/events/${event._id}`);
//                         }}>
//                           TICKETS & DETAILS
//                         </Button>
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </Slider>
//           )}

//           {/* Custom Navigation Arrows */}
//           <button
//             className="carousel-arrow carousel-arrow-left"
//             onClick={() => sliderRef.current.slickPrev()}
//             aria-label="Previous slide"
//           >
//             <svg
//               width="24"
//               height="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 d="M15 18L9 12L15 6"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           </button>
//           <button
//             className="carousel-arrow carousel-arrow-right"
//             onClick={() => sliderRef.current.slickNext()}
//             aria-label="Next slide"
//           >
//             <svg
//               width="24"
//               height="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 d="M9 18L15 12L9 6"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           </button>
//         </div>
//       </Container>
//     </section>
//   );
// }

import React, { useRef, useEffect, useState, useMemo } from "react";
import { Button, Container } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import {
//   formatToDate,
//   formatToMonth,
//   formatToUSDate,
// } from "../../utils/dateFormat";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { FaRegClock } from "react-icons/fa";
import DefaultEventImage from "../../assets/images/event/DefaultEventPhoto.svg";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { formatEventDate } from "../../utils/formatEventDate";
import { formatEventDateBadge } from "../../utils/formatEventDateBadge";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

export default function LatestEvents({ nextMonthUpcomingEvents, loading }) {
  const sliderRef = useRef(null);
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.USER_DATA);

  /* ---------------- SCREEN WIDTH ---------------- */
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ---------------- DEVICE TYPE ---------------- */
  const device = useMemo(() => {
    if (width <= 768) return "mobile";
    if (width <= 1200) return "tablet";
    return "desktop";
  }, [width]);

  /* ---------------- SLIDER SETTINGS ---------------- */
  const settings = useMemo(() => {
    if (device === "desktop") {
      return {
        infinite: true,
        speed: 500,
        arrows: false,
        focusOnSelect: true,
        centerMode: true,
        centerPadding: "100px",
        slidesToShow: 2.2,
      };
    }

    // TABLET + MOBILE
    return {
      infinite: true,
      speed: 500,
      arrows: false,
      focusOnSelect: false,
      centerMode: true,
      centerPadding: "0px",
      slidesToShow: 1,
    };
  }, [device]);

  // const isMembershipValidForEvent = (expiryDate, eventDate) => {
  //   if (!expiryDate || !eventDate) return false;

  //   return new Date(expiryDate).getTime() >= new Date(eventDate).getTime();
  // };

  return (
    <section className="latest-events my-5 py-5">
      <Container>
        {/* Header */}
        <div className="d-flex justify-content-center align-items-center text-center mb-4">
          <div className="d-flex flex-column ms-auto home-headers">
            <h2 className="team-title mb-2 h1">Upcoming Events</h2>
          </div>
          <NavLink
            as={Link}
            to="/events"
            className="view-all-link ms-auto text-decoration-none"
          >
            View All
          </NavLink>
        </div>

        <div className="position-relative latest-events-wrapper">
          {loading || !nextMonthUpcomingEvents ? (
            <div className="d-flex justify-content-center">
              <Skeleton height={450} width={800} borderRadius={12} />
            </div>
          ) : (
            <Slider
              key={device} // 🔑 FORCE REMOUNT (CRITICAL)
              ref={sliderRef}
              {...settings}
              className="latest-events-slider"
            >
              {nextMonthUpcomingEvents.map((event) => {
                // const startDate = new Date(event?.start_date);
                // const endDate = new Date(event?.end_date);

                // let dateLabel =
                //   endDate && startDate.toDateString() !== endDate.toDateString()
                //     ? `${formatToUSDate(event.start_date)} - ${formatToUSDate(
                //         event.end_date
                //       )}`
                //     : formatToUSDate(event.start_date);

                return (
                  <div key={event._id} className="slider-item-wrapper">
                    <div className="event-carousel-card">
                      <img
                        src={
                          event.image_path
                            ? `${IMAGE_BASEURL}${event.image_path}`
                            : DefaultEventImage
                        }
                        alt={event.title}
                        className="event-slider-img"
                      />

                      {/* Date Badge */}
                      {/* <div className="event-date-badge">
                        <div className="date-number">
                          {formatToDate(event.start_date)}
                        </div>
                        <div className="date-month">
                          {formatToMonth(event.start_date)}
                        </div>
                      </div> */}

                      {(() => {
                        const { day, month } = formatEventDateBadge(event);
                        return (
                          <div className="event-date-badge">
                            <div className="date-number">{day}</div>
                            <div className="date-month">{month}</div>
                          </div>
                        );
                      })()}

                      {/* Overlay */}
                      <div className="event-details-overlay">
                        <h4>{event.title}</h4>

                        {event?.price && (
                          <div>
                            {/* {user &&
                            user.is_membership_active &&
                            isMembershipValidForEvent(
                              user.membership_expiry_date,
                              event?.start_date
                            ) ? (
                              <span>
                                Free to{" "}
                                {new Date(event?.start_date).getFullYear()}{" "}
                                Members
                              </span>
                            ) : (
                              <span>
                                Non-Members ${Number(event.price).toFixed(2)}
                              </span>
                            )}  */}

                            <div className="event-overlay-price mb-2">
                              Non-Members ${Number(event.price).toFixed(2)}
                            </div>
                            {/* <br /> */}
                            <div className="event-overlay-member-price mb-3">
                              {user?.member_price
                                ? ` ${new Date(
                                    event?.start_date
                                  ).getFullYear()} Members: ${
                                    user?.member_price
                                  }`
                                : `Free to ${new Date(
                                    event?.start_date
                                  ).getFullYear()} Members`}
                            </div>
                          </div>
                        )}

                        <div className="event-overlay-info">
                          <div className="d-flex align-items-center">
                            <div className="bg-icons">
                              <FaRegClock />
                            </div>
                            <span>{formatEventDate(event)}</span>
                          </div>

                          <div className="d-flex align-items-center mt-2">
                            <div className="bg-icons">
                              <HiOutlineLocationMarker />
                            </div>{" "}
                            <span>{event.venue || "TBD"}</span>
                          </div>
                        </div>

                        <Button
                          className="btn-event-details"
                          onClick={() => navigate(`/events/${event._id}`)}
                        >
                          TICKETS & DETAILS
                        </Button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          )}

          {/* Arrows (Desktop Only) */}
          {/* {device === "desktop" && ( */}
          <>
            <button
              className="carousel-arrow carousel-arrow-left"
              onClick={() => sliderRef.current?.slickPrev()}
            >
              ‹
            </button>
            <button
              className="carousel-arrow carousel-arrow-right"
              onClick={() => sliderRef.current?.slickNext()}
            >
              ›
            </button>
          </>
          {/* )} */}
        </div>
      </Container>
    </section>
  );
}
